import React from "react";
import BookDisplay from "./components/BookDisplay";
import BookCollection from "./components/BookCollection";
import Footer from "../../common/UI/Footer";
import EbookCategoriesCarousel from "./components/EbookCategoriesCarousel";
import { useCategories } from "../../hooks/categories/useCategories";
import Loading from "../../common/HousGlass Loader/Loading";
import OverlayHome from "../../Homepage/components/OverlayHome";

function HindiReadingHome() {
  const { categories, isLoading, isError, error } = useCategories(
    "Ebook",
    "hindi"
  );

  // Render loading state
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Loading />
      </div>
    );
  }

  // Handle error state
  if (isError) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
        Error loading categories:{" "}
        {error?.message || "An unknown error occurred"}
      </div>
    );
  }

  return (
    <>
      <OverlayHome type={"HindiReadings"} category={"book"} />


      <BookDisplay languageName={"hindi"} />
      {categories && categories.length > 0 ? (
        categories.map((category) => (
          <EbookCategoriesCarousel
            key={category.id}
            categoryName={category.name}
          />
        ))
      ) : (
        <div style={{ padding: "20px", textAlign: "center" }}>
          No categories available
        </div>
      )}
      <BookCollection />
      <Footer />
    </>
  );
}

export default HindiReadingHome;
